'use client';
import { objectKeys } from '../object.js';

/**
 * Удаляет ключи из объекта, значения которых удовлетворяют заданному условию.
 *
 * @typeParam T - Тип объекта
 * @typeParam V - Тип значения в объекте, по умолчанию unknown
 *
 * @param object - Исходный объект, из которого требуется удалить ключи
 * @param condition - Функция, проверяющая значение. Если возвращает true, то ключ будет удалён из результата.
 *
 * @returns Новый объект, содержащий ключи и значения, которые не удовлетворяют условию
 *
 * @primaryExample
 * omitIf(
 *     { name: 'Alice', age: 30, active: false },
 *     (value) => typeof value === 'boolean'
 * )
 * // { name: 'Alice', age: 30 }
 *
 * @note
 * Функция возвращает новый объект, не изменяя исходный.
 */ const omitIf = (object, condition)=>{
    const result = {};
    for (const key of objectKeys(object)){
        if (!condition(object[key])) {
            result[key] = object[key];
        }
    }
    return result;
};

export { omitIf };
//# sourceMappingURL=omitIf.js.map
